/* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';

const MyFileDropzone = ({ id, onUpload, label }) => {
  // The unique 'id' is passed into the callback via closure
  const onDrop = useCallback((acceptedFiles) => {
    onUpload(acceptedFiles, id);
  }, [id, onUpload]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  return (
    <div
      {...getRootProps()}
      className="zackat-divsquare"
      id={id}
      title="For best results, create a polygon outline around the job work site, allowing for GPS coordinates to be detected when the Associate is within the polygon"
      style={{
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        color: '#383838',
        border: isDragActive ? '2px dashed #F6821E' : '2px dashed transparent',
      }}
    >
      <input {...getInputProps()} id={id} />
      <div style={{ border: 'dashed', borderColor: '#F6821E' }}>
        <p>{isDragActive ? 'Drop files here...' : label}</p>
      </div>
    </div>
  );
};
export default MyFileDropzone;
